import { observer } from 'mobx-react';
import { CopyLinkView } from './CopyLink';
import { RecordCard } from '@project/store/shared/RecordCard';
import { MapWidgetLinkBuilder } from '../../../../utils/mapWidget';
import { useStore } from '../../../hooks';

export interface MapWidgetLinkItemProps {
  card: RecordCard;
}

export const MapWidgetLinkItem = observer(
  ({ card }: MapWidgetLinkItemProps) => {
    const { news, events, map } = useStore();

    const center = map.mapProperties.center;
    const zoom = map.mapProperties.zoom;
    const layers = map.layerCollection.layers.map((v) => v.name);

    const { tableName, recordId } = card;
    const layerName = card.connectedLayer.layerName;

    const linkBuilder = new MapWidgetLinkBuilder();

    if (center !== undefined) {
      const [x, y] = center;

      if (x !== undefined && y !== undefined) {
        linkBuilder.setCenter([x, y]);
      }
    }

    if (zoom !== undefined) linkBuilder.setZoom(zoom);
    if (layers !== undefined) linkBuilder.setLayers(layers);

    linkBuilder.setNewsEnabled(news.layerController.isVisible);
    linkBuilder.setEventsEnabled(events.layerController.isVisible);
    linkBuilder.setCard({ tableName, recordId: recordId + '', layerName });

    const link = linkBuilder.build();

    const iFrameUrl = `<iframe src='${link}' width='800px' height='600px'></iframe>`;

    return <CopyLinkView url={iFrameUrl} title="Ссылка для встраивания" />;
  },
);
